import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';

import { accountService, alertService, lockerService } from '../../_services';
import Dialog from 'react-bootstrap-dialog';
import { Table, Collapse } from "react-bootstrap";

import moment from 'moment';
import { render } from 'react-dom';
import { useTranslation } from 'react-i18next';
import LocaleContext from '../../LocaleContext';
import { isActiveReservation, getReservationEndDateTime } from '../../_helpers/reservations';

function List({ history, match }) {

    let open_dialog = useRef(null);
    let end_dialog = useRef(null);
    let transfer_dialog = useRef(null);


    let { listType } = useParams();
    const [reservations, setReservations] = useState(null);
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);
    const [pricing, setPricing] = useState(null);

    async function fetchData() {
        const pricing = await lockerService.getLockerPricing();
        setPricing(pricing);
    }
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (listType == 'active') {
            accountService.getActiveReservations().then(x => setReservations(x));
        } else if (listType == 'past') {
            accountService.getPastReservations().then(x => setReservations(x));
        } else {
            accountService.getAllReservations().then(x => setReservations(x));
        }
        console.log("Reservations fetched for list type: ", listType);
    }, [listType]);

    function transferLockerForReservation(id, gui_admin, message_text) {
        transfer_dialog.show({
            bsSize: 'lg',
            body: message_text,

            actions: [
                Dialog.CancelAction(() => {
                    setReservations(reservations.map(x => {
                        if (x.id === id) { x.isTransferringLocker = false; }
                        return x;
                    }));
                }),
                Dialog.OKAction(() => {

                    //console.log("pushing to transfer page...");
                    history.push("/transfer-reservation/" + id);
                    
                    /*
                    accountService.transferLockerForReservation(id, gui_admin).then((data) => {
                        setReservations(reservations =>
                            reservations.map(x => {
                                if (x.id === id) { x.isTransferringLocker = false; }
                                return x;
                            }));
                    }).catch(err => {
                        alertService.error(err);
                        setReservations(reservations =>
                            reservations.map(x => {
                                if (x.id === id) { x.isTransferringLocker = false; }
                                return x;
                            }));
                    });

                    setReservations(reservations.map(x => {
                        if (x.id === id) { x.isTransferringLocker = true; }
                        return x;
                    }));
                    */


                })
            ]
        });
    }
    function extendRentalForReservation(id) {
        history.push("/extend-reservation/" + id);
    }
    function openLockerForReservation(id, gui_admin, message_text) {
        open_dialog.show({
            bsSize: 'lg',
            body: message_text + gui_admin + " ?",

            actions: [
                Dialog.CancelAction(() => {
                    setReservations(reservations.map(x => {
                        if (x.id === id) { x.isOpeningLocker = false; }
                        return x;
                    }));
                }),
                Dialog.OKAction(() => {

                    accountService.openLockerForReservation(id, gui_admin).then((data) => {
                        setReservations(reservations =>
                            reservations.map(x => {
                                if (x.id === id) { x.isOpeningLocker = false; }
                                return x;
                            }));
                    }).catch(err => {
                        alertService.error(err);
                        setReservations(reservations =>
                            reservations.map(x => {
                                if (x.id === id) { x.isOpeningLocker = false; }
                                return x;
                            }));
                    });

                    setReservations(reservations.map(x => {
                        if (x.id === id) { x.isOpeningLocker = true; }
                        return x;
                    }));


                })
            ]
        });
    }

    function endRentalForReservation(id, gui_admin, language) {

        setReservations(reservations.map(x => {
            if (x.id === id) { x.isEndingRental = true; }
            return x;
        }));

        const bodyEnd = (
            <p className="endRentalModal" >
                You will no longer have access to the locker! <br></br>
                Make sure you have removed all of your belongings. <br></br>
                End Rental for Locker # {gui_admin} ?
            </p>
        );

        const bodyEndFr = (
            <p className="endRentalModal" >
                Vous n'aurez plus accès au casier ! <br></br>
                Assurez-vous d'avoir retiré tous vos biens. <br></br>
                Fin de location pour casier # {gui_admin} ?
            </p>
        );

        end_dialog.show({
            bsSize: 'lg',
            body: (locale == 'fr-CA') ? bodyEndFr : bodyEnd,
            primaryClassName: 'btn-danger',
            onHide: (dialog) => {
                console.log("Cancel Background");
                dialog.hide();
                setReservations(reservations.map(x => {
                    if (x.id === id) { x.isEndingRental = false; }
                    return x;
                }))
            },
            actions: [
                Dialog.CancelAction(() => {
                    console.log("Cancel");
                    setReservations(reservations.map(x => {
                        if (x.id === id) { x.isEndingRental = false; }
                        return x;
                    }));
                }),
                Dialog.OKAction(() => {

                    accountService.endRentalForReservation(id, gui_admin).then((data) => {
                        console.log(data);
                        setReservations(reservations => reservations.filter(x => x.id !== id));
                    })
                        .then(() => {
                            console.log(reservations);
                            //reservation list length is 1 on last delete, go home instead of to empty list.
                            if (reservations.length == 1) {
                                history.push("/");
                            }
                        }).catch(err => {
                            alertService.error(err);
                            setReservations(reservations =>
                                reservations.map(x => {
                                    if (x.id === id) { x.isEndingRental = false; }
                                    return x;
                                }));
                        });
                })
            ]
        });

    }
    function refundedDisplay(refundedValue) {
        if (refundedValue == "true") {
            return "Refunded";
        } else {
            return "";
        }
    }

    function transferLockerModalMessage() {
           return (
                <p className="endRentalModal" >
                   To transfer your rental, take your belongings to the new area. <br></br>
                   Click OK when you are at the new area and ready to be assigned a new locker. <br></br>
                    
                </p>
            )
    }

    function colSpanWidth() {
        if (listType == 'past') {
            return 5;
        } else {
            return 4;
        }
    }

    //if the resrvation is redeemed ("checked in") show open, transfer, and end buttons
    //if the reservation is not redeemed, show check in button
    //otherwise no buttons
    function reservationRowButtons(reservation) {
        const lockerPrice = pricing && pricing.find(x => x.name === reservation.lockerType)?.price;
        if (listType === 'past') { return (<><td colSpan={colSpanWidth()}></td></>); }
        if (isActiveReservation(reservation)) {
            return (
                <>
                    <td colSpan={4}>
                        <div style={{ display: 'flex'}}>

                            <div style={{ width: '33%', padding: '3px' }}>
                                <button
                                    onClick={(e) => { openLockerForReservation(reservation.id, reservation.lockerGuiAdmin, t('Open Locker #')) }}
                                    className="btn btn-sm btn-success blue-btn-edit"
                                    style={{ width: '100%' }}
                                    disabled={reservation.isOpeningLocker}>
                                    {reservation.isOpeningLocker
                                        ? <span className="spinner-border spinner-border-sm"></span>
                                        : <span>{t('Open')}<br />{t('Locker')}</span>
                                    }
                                </button>
                            </div>
                            <div style={{ width: '33%', padding: '3px' }} >


                                {accountService.configValue['showTransferRentalButton'] == 'true' && 
                                lockerPrice <= reservation.paymentAmount - 1 &&
                                <button
                                    onClick={(e) => { transferLockerForReservation(reservation.id, reservation.lockerGuiAdmin, transferLockerModalMessage()) }}
                                    className="btn btn-sm btn-primary blue-btn-edit"
                                    style={{ width: '100%' }}
                                    disabled={reservation.isTransferringLocker}>
                                    {reservation.isTransferringLocker
                                        ? <span className="spinner-border spinner-border-sm"></span>
                                        : <span>{t('Transfer')}<br />{t('Locker')}</span>
                                    }
                                </button>
                                }
                                {(accountService.configValue['multiDay'] == 'true') &&
                                    <button 
                                    onClick={(e) => { extendRentalForReservation(reservation.id) } }
                                    className="btn btn-sm btn-primary blue-btn-edit"
                                        style={{ width: '100%' }}>
                                    <span>Extend <br /> Rental</span>
                                    </button>
                                }
                            </div>

                            <div style={{ width: '33%', padding: '3px' }} >

                                {moment(reservation.endDate).add(-1, 'days').isSameOrBefore(moment(), 'd') &&
                                    <>
                                        <button
                                            onClick={(e) => { endRentalForReservation(parseInt(reservation.id), reservation.lockerGuiAdmin, locale) }}
                                            className="btn btn-sm btn-danger blue-btn-edit"
                                            style={{ width: '100%' }}
                                            disabled={reservation.isEndingRental}>
                                            {reservation.isEndingRental
                                                ? <span className="spinner-border spinner-border-sm"></span>
                                                : <span>{t('End')}<br />{t('Rental')}</span>
                                            }
                                        </button>

                                    </>
                                }
                            </div>
                        </div>
                    </td>
                </>)
        } else if (moment(reservation.startDate).isSame(moment(), 'd') && !reservation.isEnded) {
            return (
                <>
                    <td colSpan={4}>
                        <div style={{ width: '33%', float: 'left' }} ></div>

                        <div style={{ width: '34%', display: 'inline-center', margin: '0 auto' }} >
                            <Link
                                to={{ pathname: '/activate-reservation/' + reservation.id }}
                                style={{ width: '100%', margin: '0 auto' }}
                                className="btn btn-sm btn-primary blue-btn-edit" disabled={reservation.isOpeningLocker}>
                                {reservation.isOpeningLocker
                                    ? <span className="spinner-border spinner-border-sm"></span>
                                    : <span>{t("Check - In")}</span>
                                }
                            </Link>
                        </div>
                        <div style={{ width: '33%', float: 'right' }} ></div>
                    </td>
                </>
            )
        } else {
            return (<><td colSpan={colSpanWidth()}></td></>)
        }
    }



    return (
        <div>
            {(listType == 'active') &&
                <>
                    <div className="card-header">
                        <h1 className="bold-tx">{t('Lockers')}</h1>
                        <h5 className="mar-bot-0">{t('active.intro')}</h5>
                    </div>
                </>
            }

            {(listType == 'past') &&
                <>
                    <h1 className="card-header">{t('Order History')}</h1>
                </>
            }

            {(listType == 'all') &&
                <>
                    <h1 className="card-header">{t('Reservations')}</h1>
                </>
            }

            <Table className="table table-striped" responsive="lg">
                <thead>
                    <tr >
                        {listType == 'active' ? (
                            <th className="btm-bdrline">{((accountService.configValue['multiDay'] == 'true') ? t('End Date') : t('Date'))}</th>
                        ) : (
                            <th className="btm-bdrline">{((accountService.configValue['multiDay'] == 'true') ? t('Dates') : t('Date'))}</th>
                        )}
                        <th className="btm-bdrline">{t('Size')}</th>
                        <th className="btm-bdrline">{t('Locker')} #</th>
                        <th className="btm-bdrline">{t('Order')} #</th>
                        {(listType == 'past' && (reservations && reservations.some(res => res.isRefunded))) &&
                            <th className="btm-bdrline">Notes</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {reservations && reservations.map(reservation =>
                        <React.Fragment key={reservation.id}>
                            <tr className="first-row">
                                <td className="text-nowrap top-bdrline">{((accountService.configValue['multiDay'] == 'true' && listType === 'active') ? (moment(reservation.endDate).add(-1, 'days').format("YYYY-MM-DD")) : reservation.startDate)}
                                    {(accountService.configValue['multiDay'] == 'true' && listType === 'past') &&
                                        <>
                                            {" TO"}
                                            <br />
                                            {reservation.endDate}
                                        </>
                                    }
                                </td>
                                <td className="top-bdrline">{t(reservation.lockerType)}</td>
                                <td className="top-bdrline">{reservation.lockerGuiAdmin}</td>
                                <td className="top-bdrline">{reservation.orderNumber}</td>
                                {(listType == 'past') &&
                                    <td className="top-bdrline">{refundedDisplay(reservation.isRefunded.toString())} </td>
                                }
                            </tr>
                            <tr>
                                <td colSpan={colSpanWidth()}> {t('Locker')} {reservation.lockerGuiAdmin} {t('is located at')} {reservation.lockerDescription}
                                </td>
                            </tr>
                            <tr>
                                {reservationRowButtons(reservation)}
                            </tr>
                        </React.Fragment>
                    )}

                    {!reservations &&
                        <tr>
                            <td colSpan="4" className="text-center">
                                <span className="spinner-border spinner-border-lg align-center"></span>
                            </td>
                        </tr>
                    }
                </tbody>
            </Table>

            <h3 className="top-bdrline card-header cust-footer-clr"><Link to="/home" className="btn btn-link">{t('Home')}</Link></h3>
            <Dialog ref={(el) => { open_dialog = el }} />
            <Dialog ref={(el) => { end_dialog = el }} />
            <Dialog ref={(el) => { transfer_dialog = el }} />

        </div>
    );
}

export { List };